'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFundSecurityLendingConfig = undefined;

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility.js');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFundSecurityLendingConfig = function getFundSecurityLendingConfig(data) {
  if ((0, _ramda.isNil)(data)) {
    return null;
  }

  return {
    securitiesLendingOverviewData: {
      type: 'securityLendingOverviewCard',
      header: _string_utility2.default.renderFormattedLabel("Securities lending overview", 'pdp-securities-lending-overview-label'),
      id: 'securities-lending-overview'
    },
    securitiesLendingData: {
      type: 'securityLendingChild',
      breakdown: data.fund.etfSecLending,
      header: _string_utility2.default.renderFormattedLabel("Securities lending data", 'pdp-securities-lending-data-label'),
      id: 'securitiesLendingDataCard',
      disclosureText: data.fund.disclosures.pdpCardSecuritiesLendingData,
      placementId: 'pdpCardSecuritiesLendingData',
      disclosures: data.fund.disclosures,
      excelDownloadType: 'securitiesLendingData',
      shouldAlwaysShowMore: (0, _ramda.includes)("ALWAYS_SHOW_MORE_DISCLOSURES", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data))
    },
    topPositionsOfSecuritiesHeldAsCollateral: {
      type: 'securityLendingChild',
      breakdown: data.fund.cltrlSecuritiesSecLending,
      header: _string_utility2.default.renderFormattedLabel('Top positions of securities held as collateral', 'pdp-top-positions-of-securities-label'),
      id: 'topPositionsOfSecuritiesHeldAsCollateralCard',
      disclosureText: data.fund.disclosures.pdpCardTopPositionsOfSecuritiesHeldAsCollateral,
      placementId: 'pdpCardTopPositionsOfSecuritiesHeldAsCollateral',
      subColumnHeader: !(0, _ramda.isNil)(data.fund.cltrlSecuritiesSecLending) ? [_string_utility2.default.renderFormattedLabel('ISIN', 'pdp-top-positions-of-securities-header-isin'), _string_utility2.default.renderFormattedLabel('Name', 'pdp-top-positions-of-securities-header-name'), _string_utility2.default.renderFormattedLabel('Currency', 'pdp-top-positions-of-securities-header-currency'), _string_utility2.default.renderFormattedLabel('Weight', 'pdp-top-positions-of-securities-header-weight')] : null,
      excelDownloadType: 'cltrlSecuritiesSecLending',
      shouldAlwaysShowMore: (0, _ramda.includes)("ALWAYS_SHOW_MORE_DISCLOSURES", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data))
    },
    securityLendingApprovedBorrowers: {
      type: 'securityLendingApprovedBorrowersCard',
      header: _string_utility2.default.renderFormattedLabel("Approved borrowers", 'pdp-securities-lending-approved-borrowers-label'),
      data: data.fund.securityLendingApprovedBorrowers,
      id: 'securities-lending-approved-borrowers'
    },
    collateralRequirement: {
      type: 'securityLendingChild',
      breakdown: data.fund.secLendingCollateralRequirement,
      header: _string_utility2.default.renderFormattedLabel('Collateral requirements', 'pdp-collateral-requirement-label'),
      id: 'collateralRequirementCard',
      subColumnHeader: [_string_utility2.default.renderFormattedLabel('Type of loan', 'pdp-collateral-requirement-type-of-loan'), _string_utility2.default.renderFormattedLabel('Minimum collateral requirement', 'pdp-collateral-requirement-min-collateral-req')]
    }
  };
};

exports.getFundSecurityLendingConfig = getFundSecurityLendingConfig;